import { Component, OnInit } from '@angular/core';
import { FirstLogin, IFirstLogin, IUser } from 'app/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'app/layouts/homepage/services/user.service';
import { DataSharingService } from 'app/layouts/homepage/services/data-sharing.service';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { SERVER_API_URL } from 'app/app.constants';

@Component({
    selector: 'jhi-first-login',
    templateUrl: './first-login.component.html',
    styleUrls: ['../../../../../content/scss/styles.scss']
})
export class FirstLoginComponent implements OnInit {
    user: IUser;
    userForm: FormGroup;
    submitted = false;
    errorCheck = false;
    showAnswer = false;
    showNewPassword = false;
    showOldPassword = false;
    showConfirmNewPassword = false;
    verifiedPhone = false;
    verifiedEmail = false;
    appUrl = '';
    successMsg: string;
    faEyeSlash = faEyeSlash;
    errorMsg = '';

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private userService: UserService,
        private dataSharing: DataSharingService,
        private router: Router
    ) {
        this.createForm();
        this.appUrl = this.route.snapshot.queryParamMap.get('appUrl');
    }

    ngOnInit() {
        this.getInitData();
    }

    private createForm() {
        this.userForm = this.formBuilder.group({
            username: [''],
            oldPassword: ['', [Validators.required]],
            newPassword: ['', [Validators.required]],
            confirmNewPassword: ['', [Validators.required]],
            email: ['', [Validators.required]],
            altEmail: [''],
            phone: ['', [Validators.required]],
            question: ['', [Validators.required]],
            answer: ['', [Validators.required]]
        });
    }

    get f() {
        return this.userForm.controls;
    }
    get fUsername() {
        return this.userForm.get('username');
    }
    get fOldPassword() {
        return this.userForm.get('oldPassword');
    }
    get fNewPassword() {
        return this.userForm.get('newPassword');
    }
    get fConfirmNewPass() {
        return this.userForm.get('confirmNewPassword');
    }
    get fEmail() {
        return this.userForm.get('email');
    }
    get fAltEmail() {
        return this.userForm.get('altEmail');
    }
    get fPhone() {
        return this.userForm.get('phone');
    }
    get fQuestion() {
        return this.userForm.get('question');
    }
    get fAnswer() {
        return this.userForm.get('answer');
    }

    onSubmit() {
        this.errorCheck = true;
        // stop here if form is invalid
        if (this.userForm.invalid) {
            return;
        }
        if(this.userForm.get('email').value === this.userForm.get('altEmail').value){
            return;
        }
        this.submitted = true;
        const outObj: IFirstLogin = new FirstLogin(
            this.fOldPassword.value,
            this.fNewPassword.value,
            this.fConfirmNewPass.value,
            this.fEmail.value,
            this.fAltEmail.value,
            '+39' + this.fPhone.value,
            this.fQuestion.value,
            this.fAnswer.value
        );
        this.userService
            .firstLogin(outObj)
            .toPromise()
            .then(res => {
                if (!this.verifiedEmail || !this.verifiedPhone) {
                    this.router.navigate(['../verificaOtp'], { relativeTo: this.route });
                } else {
                    if (res && res.body && res.body.message) {
                        this.successMsg = res.body.message;
                    } else {
                        this.successMsg = 'Operazione effettuata con successo';
                    }
                }
            })
            .catch(err => {
                if (err && err.error) {
                    this.errorMsg = err.error.message;
                }
            })
            .finally(() => {
                this.submitted = false;
            });
    }

    onReset() {
        this.submitted = false;
        // this.userForm.reset();
        this.fQuestion.reset();
        this.fAnswer.reset();
        this.fPhone.reset();
        this.fEmail.reset();
        this.fAltEmail.reset();
        this.fNewPassword.reset();
        this.fOldPassword.reset();
        this.fConfirmNewPass.reset();
    }

    private getInitData() {
        this.userService
            .getLogged()
            .toPromise()
            .then(res => {
                this.user = res.body;
                this.verifiedPhone = res.body.phoneVerified;
                this.verifiedEmail = res.body.emailVerified;
                this.populateForm();
            })
            .catch(err => {
                // console.log(err);
            })
            .finally(() => {
                // console.log('end');
            });
    }

    private populateForm() {
        this.userForm.patchValue({
            username: this.user.login,
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            email: this.user.email,
            altEmail: '',
            phone: this.user.phone,
            question: this.user.challengeQuestion,
            answer: this.user.challengeAnswer
        });
        this.verifiedPhone = this.user.phoneVerified;
        this.verifiedEmail = !this.user.emailVerified;
    }

    changeShowConfirmNewPassword() {
        this.showConfirmNewPassword = !this.showConfirmNewPassword;
    }

    changeShowNewPassword() {
        this.showNewPassword = !this.showNewPassword;
    }

    changeShowOldPassword() {
        this.showOldPassword = !this.showOldPassword;
    }

    changeShowAnswer() {
        this.showAnswer = !this.showAnswer;
    }

    backToApp() {
        this.userService
            .isUserLoggedParams(this.appUrl)
            .toPromise()
            .then(res => {
                window.location.href = 'http://' + this.appUrl;
            })
            .catch(err => {
                // console.log(err);
            })
            .finally(() => {
                // console.log('end');
            });
    }

    doRedirect() {
        window.location.href = SERVER_API_URL + 'private/logoutToChangeProfile';
    }
}

// https://access.mef.gov.it/tl/login?bmctx=3E15199FE6B574D12F736371EE5CED2D&password=secure_string&contextType=external&max_authn_level=4&username=string&challenge_url=https%3A%2F%2Faccess.mef.gov.it%2Ftl%2Flogin&request_id=4044946633814300135&authn_try_count=0&locale=en_US&resource_url=https%253A%252F%252Fidm.mef.gov.it%252Fmodificaprofilo%252Fprivate%252Fmyprofile.jsp%253FappUrl%253Dhttps%25253A%25252F%25252Fmonitoraggioprovvedimenti.mef.gov.it%25252Fmonitoraggioprovvedimenti%25252Fprivate
